{
	"arrived-to-iceland": "Komið til Íslands",
	"delivered": "Afhent",
	"delivery-method": "Afhendingarmáti",
	"DPH": "Pakki heim",
	"DPO": "Pakki Póstbox",
	"DPP": "Pakki pósthús",
	"custNumber": "Tollsendingarnúmer",
	"enter-shipment-code": "Sláðu inn sendingarnúmer",
	"estimated-delivery": "Áætlaður afhendingartími",
	"home-delivery-message": "Viltu fá sendingu heim að dyrum?",
	"send-receipt": "Senda inn reikning",
	"in-customs": "Í tollameðferð",
	"in-customs-status": "Í tollameðferð - Ertu búin/n að senda inn reikning?",
	"in-origin-country": "Á leið til landsins",
	"in-iceland": "Á Íslandi",
	"invalid-shipment-code": "Ógilt sendingarnúmer",
	"left-the-country": "Farið frá landi",
	"mailed-date": "Póstlagt",
	"save-tracking-number": "Vistaðu sendinguna til að búa til flýtileið fyrir sendingarnúmerið",
	"save": "Vista",
	"name": "Nafn (Valfrjálst)",
	"order-home-delivery": "Panta heimsendingu",
	"payment": "Greiðsla gjalda",
	"ready-for-delivery": "Tilbúið til afhendingar",
	"returned": "Endursent",
	"redirect-to-first": "Ef þú ert viss um að sendingarnúmerið sé rétt þá er líklegt að sendingin sé ekki komin til okkar.",
	"redirect-to-second": "Þú getur skoðað stöðu á sendingunni alþjóðlega hérna: ",
	"search-for-shipment": "Leita að sendingu",
	"shipment-events": "Sendingarsaga",
	"shipment-in-transit": "Sending í póstflutningi",
	"shipment-received": "Sending móttekin af Póstinum",
	"shipment-registered": "Sending skráð",
	"shipmentInOurSystem": "Sending móttekin af Póstinum",
	"status": "Staðan",
	"tracking-number": "Sendingarnúmer",
	"type": "Tegund sendingar",
	"unknown-error": "Eitthvað fór úrskeiðis, tókst ekki að finna sendingu",
	"waitingForDocuments": "Beðið eftir gögnum",
	"waitingForShipmentToArrive": "Sending bíður eftir að pakkinn kemst til okkar. Væntanleg í kerfi póstsins.",
	"weight": "Þyngd",
	"multipleParcels": "Margir pakkar fundust fyrir þetta sendingarnúmer:"
}
